import { render, staticRenderFns } from "./KosmoTextarea.vue?vue&type=template&id=bbce30c6&scoped=true"
import script from "./KosmoTextarea.vue?vue&type=script&lang=js"
export * from "./KosmoTextarea.vue?vue&type=script&lang=js"
import style0 from "./KosmoTextarea.vue?vue&type=style&index=0&id=bbce30c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce30c6",
  null
  
)

export default component.exports